// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-title--FJg1C{font-size:13px}", "",{"version":3,"sources":["webpack://./src/pages/ContractDetails/RightPanel/Billing/HideContractLinesInInvoice/components/custom-toggle-title.module.scss"],"names":[],"mappings":"AAAA,qBACE,cAAA","sourcesContent":[".button-title {\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button-title": "button-title--FJg1C"
};
export default ___CSS_LOADER_EXPORT___;
